<template>
    <div class="uk-padding">
        <h1 class="uk-heading-line uk-text-center">Partnerships</h1>
        <div class="uk-container uk-container-small">
            <div class="uk-child-width-1-4@m" uk-grid>
                <div>
                    <img src="../../../../public/ccc.png" alt="">
                </div>
                <div>
                    <img src="../../../../public/rn.png" alt="">
                </div>
                <div>
                    <img src="../../../../public/aicpa.png" alt="">
                </div>
                <div>
                    <img src="../../../../public/qbpng.png" alt="">
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "partnerships"
    }
</script>

<style scoped>

</style>